import { render, staticRenderFns } from "./CountrySelect.vue?vue&type=template&id=56a523b9&"
import script from "./CountrySelect.vue?vue&type=script&lang=js&"
export * from "./CountrySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports